<template>
  <div class="container-fluid mt-2">
    <h2>Events Management</h2>
    <b-tabs>
      <b-tab title="Benutzer">
        <BaseEventManager type="user"/>
      </b-tab>
      <b-tab title="Web Hooks">
        <BaseEventManager :type="'webhook'"/>
      </b-tab>
      <b-tab title="Zeitlich geplant">
        <BaseEventManager :type="'time'"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BaseEventManager from '@/components/digitalfirm/events/BaseEventManager.vue'

export default {
  name: 'EventManageView',
  components : {
    BaseEventManager,
  }
}
</script>
